import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ActivatedRoute, Router } from "@angular/router";
import Swal, { SweetAlertType } from "sweetalert2";

import { AuthenticationService } from "../services/auth.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  alertHTML(html: string, icon: SweetAlertType) {
    Swal.fire({
      type: icon,
      html,
      showConfirmButton: false,
      timer: 10000
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 401) {
          if (err.error?.notPermission) {
            const html: string = `
                      <h3>Não autorizado</h3>
                      <p style="text-align: left; margin-top: 12px">
                          ${err.error.message}
                      </p>
                    `;
            this.alertHTML(html, "warning");
          }
        }

        if (err.status === 403) {
          // auto logout if 403 response returned from api
          this.authenticationService.logout();
          this.router.navigate(["/login"]);
          window.location.reload();
        }

        const error = err.error || err.statusText;
        return throwError(error);
      })
    );
  }
}
